/* eslint-disable @typescript-eslint/no-explicit-any */
import { UseFormTrigger } from 'react-hook-form'
import { AssertsShape } from 'yup/lib/object'

/* eslint-disable no-promise-executor-return */
export const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export const formatDate = (date: Date | null | string | undefined): string => {
  if (!date) return ''
  let dateString = date.toString()

  if (dateString.split('T') && dateString.split('T').length === 1) dateString = dateString.concat('T00:00:00')
  if (Date.parse(dateString)) return new Date(dateString).toLocaleDateString('en-CA')

  return date.toString()
}

export const setYearMonthValueFromMonths = (
  months: number,
  yearSelect: HTMLSelectElement,
  monthSelect: HTMLSelectElement,
) => {
  if (months) {
    yearSelect.value = ''
    monthSelect.value = ''
    const year = Math.trunc(months / 12)
    const month = months % 12
    if (year > 0) yearSelect.value = year.toString()
    else yearSelect.selectedIndex = 0

    if (month > 0) monthSelect.value = month.toString()
    else monthSelect.selectedIndex = 0
  }
}

export const phoneFormat = (phone: string) => {
  if (!phone) return phone
  let formatedInputVal = phone.replace(/\D/g, '')
  const size = formatedInputVal.length
  if (size > 0) {
    formatedInputVal = `(${formatedInputVal}`
  }
  if (size > 3) {
    formatedInputVal = `${formatedInputVal.slice(0, 4)}) ${formatedInputVal.slice(4)}`
  }
  if (size > 6) {
    formatedInputVal = `${formatedInputVal.slice(0, 9)}-${formatedInputVal.slice(9)}`
  }
  if (size > 10) {
    formatedInputVal = `${formatedInputVal.slice(0, 14)}`
  }
  return formatedInputVal
}

export const removePhoneFormat = (phoneFormated: string) => {
  let phone = phoneFormated.replace(' ', '')
  phone = phone.replace('(', '')
  phone = phone.replace(')', '')
  phone = phone.replace('-', '')

  return phone
}

export const sinFormat = (sin: string) => {
  if (!sin) return sin
  let formatedInputVal = sin.replace(/\D/g, '')
  const size = formatedInputVal.length
  if (size > 3) {
    formatedInputVal = `${formatedInputVal.slice(0, 3)}-${formatedInputVal.slice(3)}`
  }
  if (size > 6) {
    formatedInputVal = `${formatedInputVal.slice(0, 7)}-${formatedInputVal.slice(7)}`
  }
  if (size > 9) {
    formatedInputVal = `${formatedInputVal.slice(0, 11)}`
  }
  return formatedInputVal
}

export const removeSinFormat = (sinFormated: string) => {
  return sinFormated.replace(/-/g, '')
}

export const getValuesFromObject = (keys: string[], values: { [k: string]: any }) => {
  const obj: { [k: string]: any } = {}
  keys.forEach((key) => {
    obj[key] = values[key]
  })
  return obj
}

export const validateObjectValue = (object: AssertsShape<any>, trigger: UseFormTrigger<AssertsShape<any>>) => {
  const validate = (field: string) => trigger(field)

  const validateChildObject = (parentKey: string, value: { [k: string]: any }) => {
    Object.entries(value).forEach(([childKey, childValue]) => {
      if (childValue) {
        if (typeof childValue !== 'object') validate(`${parentKey}.${childKey}`)
        else if (typeof childValue === 'object')
          setTimeout(() => {
            validateChildObject(`${parentKey}.${childKey}`, childValue)
          }, 0)
      }
    })
  }

  Object.entries(object).forEach(([key, value]) => {
    if (value) {
      if (typeof value !== 'object') validate(key)
      else if (typeof value === 'object') validateChildObject(key, value)
    }
  })
}

// Phone Input
export const formatPhonesNumber = () => {
  const phones = document.querySelectorAll('.phone-input')

  function handleInput(this: HTMLInputElement) {
    this.value = phoneFormat(this.value)
  }

  phones.forEach((elem) => {
    elem.addEventListener('input', handleInput)
  })
}

// SIN Input
export const formatSIN = () => {
  const sin = document.querySelectorAll('.sin-input')

  function handleInput(this: HTMLInputElement) {
    this.value = sinFormat(this.value)
  }

  sin.forEach((elem) => {
    elem.addEventListener('input', handleInput)
  })
}

// Tooltip Adjustment
export const helpTip = () => {
  const helpTips = document.querySelectorAll('.help-tip')

  function handleMouseenter(this: HTMLInputElement) {
    const tooltip = this.querySelector('p')
    if (tooltip) {
      const tooltipWidth = tooltip.offsetWidth
      const tooltipOffset = this.getBoundingClientRect().left
      const viewportWidth = window.innerWidth

      if (tooltipOffset + tooltipWidth > viewportWidth) {
        tooltip.style.left = `${viewportWidth - tooltipOffset - tooltipWidth - 20}px`
        tooltip.classList.add('no-arrow') // Add a class to hide the arrow
      }
    }
  }

  function handleMouseleave(this: HTMLInputElement) {
    const tooltip = this.querySelector('p')
    if (tooltip) {
      tooltip.style.left = '-0.4rem'
      tooltip.classList.remove('no-arrow')
    }
  }

  helpTips.forEach((element) => {
    element.addEventListener('mouseenter', handleMouseenter)
    element.addEventListener('mouseleave', handleMouseleave)
  })
}

export const scrollToTop = () => {
  document.body.scrollTop = 0 // For Safari
  document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
}

export const calculateMonthlyAmount = (
  loanTerm: number,
  interestRate: number,
  loanAmount: number,
  financeFee: number,
) => {
  const monthlyInterestRate = interestRate / 100 / 12
  const numerator = (loanAmount + loanAmount * financeFee) * monthlyInterestRate
  const denominator = 1 - (1 + monthlyInterestRate) ** -loanTerm
  const monthlyPayment = numerator / denominator

  return monthlyPayment
}
